<template>
  <div class="nav">
   <div class="nav-left nav-content">
    <div><img  v-show="false" src="../../assets/logo.png" id="logo"></div>
    <div><router-link to="/home">{{$store.state.module1.isChina?'首页':'Home'}}</router-link></div>
    <div class="selectPro" @click="showProject()"><span v-if="projectName">{{projectName}}</span><span v-else>{{$store.state.module1.isChina?'选择项目':'Select Item'}}</span><i class="el-icon-arrow-up" :class="{upDown: upD}"></i>
    </div>
    <div v-if="false"><router-link to="apple3">评价中心</router-link></div>
   </div>
   <div class="nav-right nav-content">
     <div v-if="false"><router-link to="apple4"><i class="el-icon-search"></i></router-link></div>
     <div v-if="false"><router-link to="apple5"><i class="el-icon-bell"></i></router-link></div>
     <div><div id="user"><img  v-show="false" src="../../assets/logo.png"></div></div>
     <div style="marginRight:0.2rem;cursor:pointer;">
       <el-dropdown @command="handleCommand">
       <span><span :class="{isChosed:$store.state.module1.isChina}">语言</span>/<span :class="{isChosed:$store.state.module1.isChina===false}">language</span><i class="el-icon-arrow-down el-icon--right"></i></span>
       <el-dropdown-menu slot="dropdown">
         <el-dropdown-item :command="true">中文</el-dropdown-item>
         <el-dropdown-item :command="false">English</el-dropdown-item>
         </el-dropdown-menu>
       </el-dropdown>
     </div>
     <div @click="$emit('lot')">
       <router-link to="/login">{{user?$store.state.module1.isChina?'退出登录':'Log Out':$store.state.module1.isChina?'登录':'Log on'}}</router-link>
     </div>
   </div>
  </div>
</template>

<script>
export default {
  name: 'Header',
  props: ['upD', 'projectName', 'user'],
  components: {

  },
  data () {
    return {

    }
  },
  methods: {
    showProject () {
      this.$emit('clickPro')
    },
    handleCommand (value) {
      window.localStorage.setItem('lang', value)
      this.$store.commit('setLang', value)
    }
  }
}
</script>

<style scoped>
.upDown{
transition: all 0.4s;
transform :rotate(180deg);
}
.nav{
  width:100%;
  height:0.76rem;
  background:white;
  display:flex;
  justify-content:space-between;
  padding:0.14rem 0.15rem;
  align-items:center;
  font-weight:600;
  box-shadow:0 0.05rem 5px rgba(0,0,0,0.05);
}
#logo{
  width:0.47rem;
  height:0.47rem;
}
.nav-content{
  display:flex;
  aliem-items:center;
}
.nav-left div:first-child{
  width:0.56rem;
}
.nav-left div{
  margin-right:1.08rem;
}
.nav-right div{
  margin-left:0.27rem;
  font-size:0.14rem;
}
.nav-right div i{
   font-size:0.20rem;
}
.nav-content div{
    height:0.47rem;
    line-height:0.47rem;
}
#user{
  width:0.24rem;
  height:0.24rem;
  padding-top:0.05rem;
}
#user img{
  border-radius:50%;
}
.nav-right div:last-child{
 margin-left:0.05rem;
}
.el-icon-arrow-up{
 margin-left:0.1rem;
}
.selectPro{
  position:relative;
  cursor:pointer;
}
.isChosed{
  color:#01A3FF;
}
</style>
